(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('OrganisationDeleteController',OrganisationDeleteController);

    OrganisationDeleteController.$inject = ['$uibModalInstance', 'entity', 'Organisation'];

    function OrganisationDeleteController($uibModalInstance, entity, Organisation) {
        var vm = this;
        vm.organisation = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Organisation.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
